<template>
  <div></div>
</template>

<script>
import { composeAllAppMenuList, findUserAppAndMenu, renderAppsData, renderRouterByMenu, } from "@/util/menu";
import { registerAppByUser, setDefaultApp, startApp } from "@/util/qiankun";
import { multiplevalInDeep } from "@/library/js/array.js";
import Cookies from "js-cookie";

export default {
  name: "free-login",
  data() {
    return {
      userId: this.$route.query.userid, //用户id
      token: this.$route.query.token, //token
      routeName: this.$route.query.routename, //页面地址
      routeQuery: this.$route.query.routequery, //页面参数 以对象传入 routequery={"schoolId":"312bb19f8dd7410d8ab58fff5c681865"}
      origin: this.$route.query.origin, //来源
      edition: this.$route.query.edition, //版本
    };
  },

  methods: {
    /**
     * 解析路由参数
     */
    parseRouterParams() {
      if (this.routeQuery != "" && this.routeQuery != undefined) {
        let query = JSON.parse(this.routeQuery);
        if (query.appType) {
          return query.appType;
        }
      }
      return -1;
    }
  },

  mounted() {
    let appType = this.parseRouterParams();
    this.$store.commit("app/SET_APP_TYPE", appType);
    // Cookies.set('appType', appType);
    sessionStorage.setItem('appType', appType);

    let userParam = {
      isSaveCookie: true,
    };
    if (this.token) {
      userParam.token = this.token;
    } else {
      userParam.userId = this.userId;
    }

    this.$store
      .dispatch("user/getUserInfo", userParam)
      .then((res) => {
        //根据用户id 获取用户权限（应用和应用的菜单）
        let userMenuParam = {
          userId: this.userId,
          adminType: this.$store.getters.adminType,
          userType: this.$store.getters.userType,
          // appType: appType ? appType : this.$store.getters.appType,
        };
        if (appType == 1) {
          userMenuParam.appType = appType
        }

        findUserAppAndMenu(userMenuParam, () => {
          //项目集合
          let projects = this.$store.getters.projects;
          //应用集合
          let apps = this.$store.getters.apps;
          //所有应用的菜单
          let allAppMenuList = composeAllAppMenuList(apps);

          let registAppData = renderAppsData(projects, apps, allAppMenuList);
          //注册子项目
          registerAppByUser(registAppData);

          //根据当前路由path获取要加载的子项目、应用、菜单    （如果是根路径默认获取第一个菜单）
          //根据当前路径遍历菜单集合
          let targetMenu = multiplevalInDeep(
            allAppMenuList,
            this.routeName,
            "/",
            "module",
            "path",
            "children"
          );

          let defaultProjectRP = "",
            defaultAppId = "";
          if (targetMenu.length > 0 && targetMenu[0].path != "") {
            this.$store.dispatch("menu/setSelectedMenuId", targetMenu[0].id);
            defaultProjectRP = targetMenu[0].module;
            defaultAppId = targetMenu[0].appId;
          } else {
            defaultProjectRP = allAppMenuList[0].module;
            defaultAppId = allAppMenuList[0].appId;
          }

          //设置默认应用
          if (defaultAppId) {
            let defaultApp = apps.filter((item) => item.id === defaultAppId)[0];
            if (defaultApp) {
              this.$store.dispatch("menu/setSelectedApp", defaultApp);
              let defaultAppMenusData = renderRouterByMenu(
                defaultApp.menuTreeList,
                true
              );
              this.$store.commit("menu/SET_MENUS", defaultAppMenusData);
            }
          }

          // 设置默认子应用
          setDefaultApp(defaultProjectRP);

          //启动微服务
          startApp();
          let openUrl = this.routeName;
          if (this.routeQuery != "" && this.routeQuery != undefined) {
            let routeQueryStr = "",
              routeQueryObj = JSON.parse(this.routeQuery);
            Object.keys(routeQueryObj).forEach((key) => {
              routeQueryStr += key + "=" + routeQueryObj[key] + "&";
            });

            if (routeQueryStr != "") {
              routeQueryStr = routeQueryStr.substring(
                0,
                routeQueryStr.length - 1
              );
            }
            openUrl += "?" + routeQueryStr;
          }
          window.location.href = openUrl;
        });
      })
      .catch((res) => {
        console.log(res);
      });
  },
};
</script>

<style lang="scss" scoped></style>
